import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


// код города вылета
// магадан
// window.cityCode = 'GDX';
// благовещинск
// window.cityCode = 'BQS';

const root = ReactDOM.createRoot(document.getElementById('rootArrival'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
